import { useTranslation } from "react-i18next";

interface ProjectImage {
  id: number;
  img: string;
  title: string;
  description?: string;
}

const projects: ProjectImage[] = [
  {
    id: 1,
    img: "/1.webp",
    title: "Glass Greenhouse",
    description: "Premium climate-controlled structure"
  },
  {
    id: 2,
    img: "/2.webp",
    title: "Commercial Greenhouse",
    description: "Large-scale production facility"
  },
  {
    id: 3,
    img: "/about4.webp",
    title: "Polycarbonate Greenhouse",
    description: "Durable & energy-efficient design"
  },
  {
    id: 4,
    img: "/GreenHouse.webp",
    title: "Tunnel Greenhouse",
    description: "Cost-effective growing solution"
  },
  {
    id: 5,
    img: "/greenhouse1.jpg",
    title: "Screen House",
    description: "Natural ventilation system"
  },
  { id: 6, img: "/sustain2.webp", title: "Sustainable House", description: "Eco-friendly design" },
  { id: 7, img: "/greenhouse3.jpg", title: "Hydroponic Setup", description: "Soil-free cultivation" },
  { id: 8, img: "/greenhouse4.jpg", title: "Vertical Farm", description: "Space-saving structure" },
  { id: 9, img: "/greenhouse6.jpg", title: "Research Greenhouse", description: "Scientific cultivation" },
  { id: 10, img: "/greenhouse7.jpg", title: "Mini Greenhouse", description: "Compact urban solution" },
  { id: 11, img: "/portfolio1.png", title: "Mini Greenhouse", description: "Compact urban solution" },
  { id: 12, img: "/sustain2.webp", title: "Mini Greenhouse", description: "Compact urban solution" },
  { id: 13, img: "/sustain7.webp", title: "Mini Greenhouse", description: "Compact urban solution" },
  { id: 14, img: "/sustain1.webp", title: "Sustainable House", description: "Eco-friendly design" },
  // { id: 15, img: "/sustain3.webp", title: "Sustainable House", description: "Eco-friendly design" },
  { id: 16, img: "/sustain4.webp", title: "Sustainable House", description: "Eco-friendly design" },
  { id: 17, img: "/hero3.webp", title: "Sustainable House", description: "Eco-friendly design" },
  { id: 18, img: "/hero1.jpeg", title: "Sustainable House", description: "Eco-friendly design" },
  { id: 19, img: "/sustain5.jpeg", title: "Sustainable House", description: "Eco-friendly design" },
  { id: 20, img: "/sustain6.jpeg", title: "Sustainable House", description: "Eco-friendly design" },


];
const uniqueProjects = projects.filter(
  (project, index, self) =>
    index === self.findIndex((p) => p.img === project.img)
);

export default function GreenHouseImproved() {
  const { t } = useTranslation();

  return (
    <div className="w-full">

      {/* ================= HERO SECTION ================= */}
      <div
        className="
          relative 
          w-full 
          h-screen   /* fullscreen */
          
          bg-[url('/Glass-mobile.webp')]   /* mobile image */
          md:bg-[url('/black2.webp')]      /* desktop image */
          
          bg-cover 
          bg-center 
          bg-no-repeat
          flex items-center justify-center
        "
      >
        {/* Enhanced Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/50"></div>

        {/* Decorative Pattern Overlay */}
        <div className="absolute inset-0 opacity-10" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
        }}></div>

        {/* Content */}
        <div className="relative z-10 flex flex-col items-center justify-center h-full px-6 sm:px-10 text-center">

          {/* Small Badge */}
          <div className="mb-6 px-6 py-2 bg-white/20 backdrop-blur-md border border-green-400/30 rounded-full">
            <span className="text-green-100 text-sm sm:text-base font-medium tracking-wide">
              ✦ {t("projects_greenhouse_main_heading")}
            </span>
          </div>

          <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-black text-white mb-6 drop-shadow-2xl leading-tight">
            {t("projects_greenhouse_main_heading")}
          </h1>

          <p className="text-white/90 text-lg sm:text-xl md:text-2xl max-w-2xl font-light tracking-wide drop-shadow-lg">
            {t("projects_greenhouse_top_description")}
          </p>

          {/* Scroll Indicator */}
          <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
            <svg className="w-6 h-6 text-white/70" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
              <path d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
            </svg>
          </div>
        </div>
      </div>

      {/* ================= PROJECT GRID ================= */}
      <div className="py-20 sm:py-24 lg:py-32 px-6 sm:px-10 lg:px-20 max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-[#7EDE56] font-semibold text-sm sm:text-base tracking-widest uppercase mb-3">
            {t("projects_greenhouse")}
          </p>

          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-[#002F3F] mb-6 leading-tight">
            {t("projects_greenhouse_h1")}
          </h2>

          <div className="flex items-center justify-center gap-3 mb-8">
            <div className="h-1 w-12 bg-[#7EDE56] rounded-full"></div>
            <div className="h-2 w-2 bg-[#7EDE56] rounded-full"></div>
            <div className="h-1 w-24 bg-[#7EDE56] rounded-full"></div>
            <div className="h-2 w-2 bg-[#7EDE56] rounded-full"></div>
            <div className="h-1 w-12 bg-[#7EDE56] rounded-full"></div>
          </div>

          <p className="text-gray-600 text-base sm:text-lg md:text-xl max-w-4xl mx-auto leading-relaxed">
            {t("projects_greenhouse_description")}

          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4">
          {uniqueProjects.map((project) => (
            <div
              key={project.id}
              className="group relative cursor-pointer transform transition-all duration-500 hover:-translate-y-2"
            >
              <div className="relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-shadow duration-500 bg-gray-100">
                <div className="relative overflow-hidden h-48 sm:h-65">
                  <img
                    src={project.img}
                    srcSet={`
    ${project.img} 400w,
    ${project.img} 800w,
    ${project.img} 1200w
  `}
                    sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
                    alt={project.title}
                    loading="lazy"
                    decoding="async"
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
